import { IActionType, StudyState } from "../../types";

const participantCount = 12;
const testUserOrder = [
  [11, 1, 3, 8, 12, 13, 17, 5, 15],
  [9, 11, 0, 10, 6, 2, 8, 17, 7],
  [13, 12, 6, 9, 16, 4, 1, 3, 5],
  [16, 4, 10, 11, 17, 0, 2, 3, 14],
  [2, 12, 7, 14, 9, 15, 0, 4, 13],
  [6, 14, 1, 10, 16, 15, 7, 8, 5],
  [0, 8, 16, 1, 12, 11, 7, 6, 15],
  [11, 4, 7, 17, 9, 0, 14, 3, 16],
  [4, 14, 17, 15, 16, 10, 7, 2, 13],
  [5, 8, 3, 6, 10, 12, 17, 13, 15],
  [0, 1, 5, 9, 6, 13, 2, 3, 10],
  [1, 14, 11, 5, 9, 12, 4, 8, 2],
];

const initialState: StudyState = {
  participants: generateParticipants(participantCount),
  videoIds: generateVideoIds(),
  videoOrders: generateVideoOrders(participantCount),
  videoLabels: generateVideoLabels(),
};

function generateParticipants(num) {
  return Array(num)
    .fill("P")
    .map((_, idx) => `P${idx + 1}`);
}

function generateVideoOrders(num) {
  const videoOrders = new Map();
  const participants = generateParticipants(num);
  participants.forEach((userId, idx) => {
    videoOrders.set(userId, testUserOrder[idx]);
  });
  return videoOrders;
}

function generateVideoIds() {
  return [
    "1001",
    "1002",
    "1003",
    "2001",
    "2002",
    "2003",
    "2004",
    "2005",
    "2006",
    "2007",
    "269800164357",
    "269912885711",
    "270107511749",
    "270286443106",
    "270490620874",
    "270546866156",
    "270600868101",
    "270631231591",
  ];
}

function generateVideoLabels() {
  return ["正常", "虚假宣传", "低俗色情", "血腥暴力", "站外引流", "违禁品"];
}

export default (state = initialState, action: IActionType): StudyState => {
  return state;
};
